import React, { useState } from 'react';
import TranslationSelect from './components/TranslationSelect';
import HighScores from './components/HighScores';
import VerseChoice from './components/VerseChoice';
import './App.css';

function App() {
  const [translation, setTranslation] = useState(null);
  const [started, setStarted] = useState(false);
  const [playerName, setPlayerName] = useState("");

  const handleStart = () => {
    if (translation && playerName.trim() !== "") {
      setStarted(true);
    }
  };

  const handleGoBack = () => {
    setStarted(false);
    setTranslation(null);
    setPlayerName("");
  };

  const isStartDisabled = !translation || playerName.trim() === "";

  return (
    <div className="BackgroundWrapper">
      <div className="App">
        {!started ? (
          <>
            <HighScores />
            <h1>Bible Trivia!</h1>

            <h2>How Well Do You Know Your Bible?</h2>


            <TranslationSelect onSelect={setTranslation} />


            <div>
              <label>Choose a name:</label>
              <input
                className="namein"
                type="text"
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
              />
            </div>

            <button
              onClick={handleStart}
              disabled={isStartDisabled}
              style={{
                opacity: isStartDisabled ? 0.5 : 1,
                cursor: isStartDisabled ? 'not-allowed' : 'pointer'
              }}
            >
              Start Game
            </button>
          </>
        ) : (
          <VerseChoice
            translation={translation}
            playerName={playerName}
            onGoBack={handleGoBack}
          />
        )}
      </div>
    </div>
  );
}

export default App;
